import * as React from 'react';

const Ca24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#E1001F",
    d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#E1001F",
    d: "M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "M7 6h10v12H7V6Zm5.188 10.23-.094-1.799a.198.198 0 0 1 .231-.204l1.79.315-.242-.667a.136.136 0 0 1 .042-.152l1.96-1.588-.442-.206a.135.135 0 0 1-.07-.164l.387-1.192-1.13.24a.135.135 0 0 1-.151-.08l-.219-.514-.881.946a.136.136 0 0 1-.232-.12l.425-2.19-.68.393a.136.136 0 0 1-.19-.056L12 7.833l-.692 1.359a.136.136 0 0 1-.19.056l-.68-.394.425 2.192a.136.136 0 0 1-.156.159.135.135 0 0 1-.076-.04l-.881-.946-.219.514a.136.136 0 0 1-.152.08l-1.129-.24.387 1.192a.135.135 0 0 1-.07.164l-.442.206 1.96 1.588a.135.135 0 0 1 .042.152l-.242.667 1.79-.315a.2.2 0 0 1 .216.118.2.2 0 0 1 .015.086l-.094 1.798h.376Z"
  }
));
Ca24.Size = 24;
Ca24.Title = "Ca";

export { Ca24 as default };
